<div class="item" [ngClass]="itemClass" (mouseenter)="mouseEnter()">
  <drop-down ico="chevron_menu_24" (toggle)="toggle($event)" [visible]="open" [angle]="[-90,0]" *ngIf="hasChildren"></drop-down>
  <a (click)="select()">{{item.name}}</a>
</div>
<pages-menu *ngIf="children?.length" [items]="children" [level]="level + 1"  [ngClass]="menuClass"></pages-menu>
